import { render } from "./PhotosView.vue?vue&type=template&id=1fbd075e"
import script from "./PhotosView.vue?vue&type=script&lang=js"
export * from "./PhotosView.vue?vue&type=script&lang=js"

import "./PhotosView.vue?vue&type=style&index=0&id=1fbd075e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__